import { privateApi } from '../ApiService';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';
import { AdsConnection, CreateAdsConnection } from './types';

const createAdsConnection = async (
    businessAccountId: string,
    adsConnection: CreateAdsConnection,
): Promise<AdsConnection> =>
    privateApi.post<AdsConnection>(`business-accounts/${businessAccountId}/ads-connections`, adsConnection);

export const AdsConnectionGateway = {
    createAdsConnection,
    enableAdsConnection: async (id: string): Promise<AdsConnection> =>
        privateApi.post<AdsConnection>(`ads-connections/${id}/enable`),
    disableAdsConnection: async (id: string): Promise<AdsConnection> =>
        privateApi.post<AdsConnection>(`ads-connections/${id}/disable`),
};

const cancelableFetchAdsConnections = async (businessAccountId: string): Promise<AdsConnection[]> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<AdsConnection[]>(
        `business-accounts/${businessAccountId}/ads-connections`,
    );

export const CancelableAdsConnectionGateway = {
    cancelableFetchAdsConnections,
};
